import request from '@/utils/request'

let Rescue_service_catalogApi = {

  /*救援服务类目列表*/
  list(data) {
    return request._post('/shop/plus.rescue_service_catalog.Index/index', data);
},
listx(data) {
    return request._post('/shop/plus.rescue_service_catalog.Index/indexx', data);
},
/*添加救援服务类目*/
add(data) {
    return request._post('/shop/plus.rescue_service_catalog.Index/add', data);
},
/*修改救援服务类目*/
edit(data) {
    return request._post('/shop/plus.rescue_service_catalog.Index/edit', data);
},
/*删除救援服务类目*/
del(data) {
    return request._post('/shop/plus.rescue_service_catalog.Index/del', data);
},
/*救援服务类目详情*/
detail(data) {
  return request._post('/shop/plus.rescue_service_catalog.Index/detail', data);
},
    saveSetting(data, errorback) {
        return request._post('/shop/plus.rescue_service_catalog.Setting/getSetting', data, errorback);
    },
    getSetting(data, errorback) {
        return request._get('/shop/plus.rescue_service_catalog.Setting/getSetting', data, errorback);
    },
}
export default Rescue_service_catalogApi;



// WEBPACK FOOTER //
// ./src/api/rescue_service_catalog.js